<template>
  <div class="myEvaluate">
    <div class="head">
        <div style="flex:1;padding-left:20px;">
          <span style="flex:1;">宝贝</span>
        </div>
        <div style="flex:2;padding-right:20px;">
          <span style="flex:1;">评价时间</span>
          <span style="flex:1;">操作</span>
        </div>
    </div>
    <div class="sub-main" v-if="flag" v-loading="loading">
        <div class="content" v-for="(item,index) in evaluateList" :key="index">
            <div class="productBox">
                <div class="product">
                    <div class="left fs13">
                        <div class="box">
                            <div class="desc">
                                <img :src="item.productImage" alt="">
                                <div>
                                    <p class="name">{{item.productName}}</p>
                                    <p class="size font-color-999"><span v-for="(val,idx) in item.values" :key="idx">{{val}}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="time">
                            <p>{{item.createTime}}</p>
                        </div>
                        <div class="operate">
                            <div>
                                <p class="fs13 tex-und cur-poi" @click="toEvaluateDetail(item)">查看评价</p>
                                <p class="fs13 tex-und cur-poi" v-if="item.ifAdd==0" @click="toAddEvaluate(item)">去追评</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-pagination v-if="evaluateList.length>0" :current-page="page" :page-size="10" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='total'></el-pagination>
    </div>
    <div class="nothing" v-else>
      <img src="../../../../static/image/noorder@2x.png" alt="">
      <p class="fs20 font-color-999">你还没有评价～</p>
      <router-link to="/">
          <el-button>去首页看看</el-button>
      </router-link>
    </div>
  </div>
</template>
<script>
import api from '../../../api'
import {listSearchMixin} from '../../../config/mixin'
export default {
  mixins: [listSearchMixin],
  name: 'myEvaluate',
  data () {
    return {
      evaluateList: [],
      page: 1,
      total: 0,
      flag: true,
      loading: false
    }
  },
  mounted () {
    this.getEvaluateList()
  },
  methods: {
    // 获取评价列表
    getEvaluateList () {
    //   const rLoading = this.openLoading()
      let self = this
      self.loading = true
      let params = {
          url: api.getEvaluateList + `?state=&page=${self.page}&pageSize=10`,
          method: 'GET',
          data: {
          }
        }
        self.sendReq(params, (res) => {
          if (res.code === '200') {
              self.evaluateList = res.data.page.list
              if (res.data.page.list.length) {
                  this.flag = true
              } else {
                  this.flag = false
              }
            //   rLoading.close()
              self.loading = false
          } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
        })
    },
    // 查看评价
    toEvaluateDetail (item) {
        this.$router.push({
            path: '/evaluateDetail',
            query: {
                data: JSON.stringify(item)
            }
        })
    },
    // 去追评
    toAddEvaluate (item) {
        this.$router.push({
            path: '/addEvaluate',
            query: {
                data: JSON.stringify(item)
            }
        })
    },
    // 跳转到商品详情
    // toProductDetail (id) {
    //     this.$router.push({
    //         path: '/productDetail',
    //         query: {
    //             productId: id
    //         }
    //     })
    // },
    handleCurrentChange (val) {
      this.page = val
      this.getEvaluateList()
    }
  }
}
</script>
<style lang="scss" scoped>
.myEvaluate{
  width: 100%;
  .noorder{
        width: 100%;
        text-align: center;
        padding: 100px 0;
        p{
            margin-bottom: 20px;
        }
        .el-button{
            background-color: #FF7800;
            color: #FFFFFF;
            font-weight: normal;
            border-radius: 0;
        }
    }
    .head{
        box-sizing: border-box;
        width: 100%;
        height: 44px;
        background-color: #F1F2F7;
        display: flex;
        align-items: center;
        text-align: center;
        margin-bottom: 20px;
        div{
            display: flex;
        }
    }
    .content{
        width: 100%;
        margin-bottom: 20px;
        border: 1px solid #E5E5E5;
        border-bottom: 0;
        box-sizing: border-box;
        .productBox{
            width: 100%;
            box-sizing: border-box;
            .product{
                width: 100%;
                display: flex;
                .left{
                    flex: 1;
                    .box{
                        padding: 20px 0 20px 20px;
                        display: flex;
                        border-bottom: 1px solid #E5E5E5;
                        .desc{
                            flex: 1;
                            display: flex;
                            img{
                                width: 86px;
                                height: 86px;
                                margin-right: 10px;
                            }
                            div{
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                .name{
                                    font-size: 14px;
                                }
                                .size{
                                    font-size: 13px;
                                    span{
                                        margin-right: 10px;
                                    }
                                    span:last-child{
                                        margin-right: 0;
                                    }
                                }
                            }
                        }
                    }
                }
                .right{
                    padding: 20px 20px 20px 0;
                    flex: 2;
                    display: flex;
                    border-bottom: 1px solid #E5E5E5;
                    .time,.operate{
                        flex: 1;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        div{
                            text-align: center;
                            .el-button{
                                border: 1px solid #FF7800;
                                color: #FF7800;
                                border-radius: 0;
                            }
                        }
                    }
                }
            }
        }
    }
    >>>.el-pagination{
        margin-top: 40px;
        text-align: right;
        .el-pager{
            li:not(.disabled):hover{
                color: #FF7800;
            }
            li:not(.disabled).active{
                background-color: #FF7800;
            }
            li:not(.disabled).active:hover{
                color: #F4F4F5;
            }
        }
    }
}
.sub-main{
    min-height: 400px;
}
.nothing{
    width: 100%;
    text-align: center;
    min-height: 400px;
    p{
        margin-bottom: 20px;
    }
    .el-button{
        background-color: #FF7800;
        color: #FFFFFF;
        font-weight: normal;
        border-radius: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/myEvaluate/index.vue